var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.667,
    viewBox: "0 0 16 14.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-1.125 -2.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_515",
    "data-name": "Trazado 515",
    d: "M16.325,4.679H13.391V2.813H12.325V4.68h-6.4V2.813H4.858V4.68H1.925a.8.8,0,0,0-.8.8v11.2a.8.8,0,0,0,.8.8h14.4a.8.8,0,0,0,.8-.8V5.48a.8.8,0,0,0-.8-.8Zm-.267,11.733H2.192V5.746H4.858V7.08H5.925V5.746h6.4V7.08h1.067V5.746h2.667Z",
    transform: "translate(0)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_516",
    "data-name": "Trazado 516",
    d: "M7.875,15.75H9.044v1.169H7.875Z",
    transform: "translate(-3.572 -6.85)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_517",
    "data-name": "Trazado 517",
    d: "M14.063,15.75h1.169v1.169H14.063Z",
    transform: "translate(-6.847 -6.85)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_518",
    "data-name": "Trazado 518",
    d: "M19.688,15.75h1.169v1.169H19.688Z",
    transform: "translate(-9.823 -6.85)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_519",
    "data-name": "Trazado 519",
    d: "M25.875,15.75h1.169v1.169H25.875Z",
    transform: "translate(-13.097 -6.85)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_520",
    "data-name": "Trazado 520",
    d: "M7.875,20.813H9.044v1.169H7.875Z",
    transform: "translate(-3.572 -9.531)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_521",
    "data-name": "Trazado 521",
    d: "M14.063,20.813h1.169v1.169H14.063Z",
    transform: "translate(-6.847 -9.531)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_522",
    "data-name": "Trazado 522",
    d: "M19.688,20.813h1.169v1.169H19.688Z",
    transform: "translate(-9.823 -9.531)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_523",
    "data-name": "Trazado 523",
    d: "M25.875,20.813h1.169v1.169H25.875Z",
    transform: "translate(-13.097 -9.531)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_524",
    "data-name": "Trazado 524",
    d: "M7.875,25.875H9.044v1.169H7.875Z",
    transform: "translate(-3.572 -12.211)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_525",
    "data-name": "Trazado 525",
    d: "M14.063,25.875h1.169v1.169H14.063Z",
    transform: "translate(-6.847 -12.211)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_526",
    "data-name": "Trazado 526",
    d: "M19.688,25.875h1.169v1.169H19.688Z",
    transform: "translate(-9.823 -12.211)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_527",
    "data-name": "Trazado 527",
    d: "M25.875,25.875h1.169v1.169H25.875Z",
    transform: "translate(-13.097 -12.211)",
    fill: "#0050c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e186d5bdd7c226816d6ed5af5037bb02.svg";
export { ForwardRef as ReactComponent };